<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>
<app-hero-section></app-hero-section>
<app-grants-list [selectedLanguage]="selectedLanguage"></app-grants-list>

<app-footer></app-footer>
